import {
  HStack,
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  ModalHeader,
  Tab,
  TabList,
  Tabs,
  useColorModeValue,
} from '@ecoinvent/ui';
import { BiSearch, BiX } from 'react-icons/bi';
import { FiX } from 'react-icons/fi';
import { MdOutlineEco, MdVilla } from 'react-icons/md';

import { FlowTabType } from './types';

type Props = {
  fullscreenTab: FlowTabType;
  setFullscreenTab: (tab: FlowTabType) => void;
  filterValue: string;
  setFilterValue: (v: string) => void;
  onFilterClear: () => void;
  onClose: () => void;
};

const FullscreenHeader = ({ fullscreenTab, setFullscreenTab, filterValue, setFilterValue, onFilterClear, onClose }: Props) => {
  const headerBorderColor = useColorModeValue('gray.200', 'gray.600');

  return (
    <ModalHeader
      px={4}
      py={2}
      borderBottom="1px"
      borderColor={headerBorderColor}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Tabs
        overflowY="hidden"
        alignSelf="flex-start"
        variant="soft-rounded"
        index={fullscreenTab === 'technosphere' ? 0 : 1}
        onChange={(i) => setFullscreenTab(i === 0 ? 'technosphere' : 'ecosphere')}
      >
        <TabList maxW="100%" w="max-content">
          <Tab borderRadius="lg">
            <Icon as={MdVilla} mr={1} w="20px" height="20px" />
            Technosphere
          </Tab>
          <Tab borderRadius="lg">
            <Icon as={MdOutlineEco} mr={1} w="20px" height="20px" />
            Ecosphere
          </Tab>
        </TabList>
      </Tabs>
      <HStack spacing={2}>
        <InputGroup size="sm" w="240px">
          <InputLeftElement pointerEvents="none">
            <BiSearch />
          </InputLeftElement>
          <Input
            type="search"
            placeholder="Filter flows..."
            value={filterValue}
            onChange={(e) => setFilterValue(e.target.value)}
            borderRadius="md"
            sx={{
              '&::-webkit-search-cancel-button': { display: 'none' },
              '&::-webkit-search-decoration': { display: 'none' },
            }}
          />
          {filterValue && (
            <InputRightElement cursor="pointer" onClick={onFilterClear}>
              <Icon as={BiX} width="16px" height="16px" />
            </InputRightElement>
          )}
        </InputGroup>
        <IconButton
          aria-label="Close fullscreen"
          icon={<FiX size={16} />}
          size="sm"
          variant="ghost"
          colorScheme="gray"
          onClick={onClose}
        />
      </HStack>
    </ModalHeader>
  );
};

export default FullscreenHeader;
